import { Suspense } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from "./contexts/navigation";
import { PermissionsProvider } from "./contexts/permissions";
import { routes } from './app-routes';
import {
  useScreenSizeClass
} from "~/utils";

import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
import './themes/customization/override.datagrid.scss';
import './themes/customization/override.editors.scss';
import './themes/customization/override.treelist.scss';
import './app.scss';

const LoadingFallback = () => {
  return <LoadPanel visible={true} />;
};

function Content() {
  return useRoutes(routes);
}

function App() {
  return (
    <Suspense fallback={<LoadingFallback /> }>
      <Content />
    </Suspense>
  );
}

export function MainApp({ pca }) {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <MsalProvider instance={pca}>
        <PermissionsProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <App />
            </div>
          </NavigationProvider>
        </PermissionsProvider>
      </MsalProvider>
    </Router>
  );
}
